import React from "react";
import Cont from "./Container";
import Visit from "../About/firebase";
import About from "../About/About";
const Home = () => {
  return (
    <div>
      <Cont />
      <About />
      <Visit />
      
    </div>
  );
};

export default Home;
